import { AnimationBase, AnimationState } from "./animation-base";

export class AnimationPage extends AnimationBase<AnimationPageProps> {
    private _props: AnimationPageProps;
    private _animationProps:any = []
    public get isInited(): boolean {
        return typeof this._props !== 'undefined';
    }
    constructor(public animationType: AnimationPageType) {
        super(animationType, AnimationPageType.none);
        this._animationProps[AnimationPageType.none] = ({
            length: 0
        } as AnimationModalInternalProps)
        this._animationProps[AnimationPageType.fade] = ({
            length: 1000
        } as AnimationModalInternalProps)

        this._animationProps[AnimationPageType.slide] = ({
            length: 1000
        } as AnimationModalInternalProps)

        this._animationProps[AnimationPageType.slideUp] = ({
            length: 1000
        } as AnimationModalInternalProps)

        this._animationProps[AnimationPageType.flipX] = ({
            length: 1000
        } as AnimationModalInternalProps)

        this._animationProps[AnimationPageType.flipY] = ({
            length: 1000
        } as AnimationModalInternalProps)
    }

    public updateProps(props: AnimationPageProps) {
        this._props = props;
    }

    public setState(state: AnimationState, onDone?: () => void){
        // if(!this.isAnimationEnabled()) {
        //     if(onDone) {
        //         onDone();
        //     }
        //     return;
        // }
        const animationType = this.isAnimationsEnabled ? this.animationType : AnimationPageType.none;
        if(!this._props.page) {
            return;
        }
        const animationProps: AnimationModalInternalProps = this._animationProps[animationType];
        const pageClass = animationType + '-';
        const reversedState = state === AnimationState.In ? AnimationState.Out : AnimationState.In;

        this._props.page.classList.remove(pageClass + reversedState);
        this._props.page.classList.add(pageClass + state);

        setTimeout(() => {
            if(onDone) {
                onDone();
            }
        }, animationProps.length);
	}
}

export interface AnimationPageProps {
    page: HTMLElement;
}

export enum AnimationPageType {
    none = 'page-animation-none',
    fade = 'page-animation-fade',
    slide = 'page-animation-slide',
    slideUp = 'page-animation-slide-up',
    flipX = 'page-animation-flip-x',
    flipY = 'page-animation-flip-y'
}

interface AnimationModalInternalProps {
    length: number;
}